import {GiftManager} from "../component/gift";
import {Translator} from "../utils/translator";
export class SmartTipWidget
{
	private TAG = "[SmartToyWidget]";
	private $widget : JQuery;

	/** Number of currently available blocks */
	private blocks : number;
	private selected: number = 6;

	constructor(private $root : JQuery,
	            private giftManager : GiftManager,
	            private translator : Translator,
	            private onSend : Function)
	{
		this.initWidget();
		this.$root.find("button.send").click(() => this.sendSelected());
	}

	private sendSelected()
	{
		let price = this.getPrice(this.selected);
		this.onSend(price);

		if (price < 200) this.select(this.selected + 1);
	}

	public resize(w : number)
	{
		// logging.log("smarttips resize", w);
		this.createBlocks(w);
		this.select(this.selected);
	}

	//noinspection JSMethodCanBeStatic
	public getPrice(selection : number)
	{
		const priceList = [50, 60, 70, 80, 90, 100, 125, 150, 175, 200, 250, 350, 500, 750];
		return priceList.length > selection ? priceList[selection - 1] : (250 * (selection - 11));
	}

	public select(idx)
	{
		let $blocks = this.$widget.find(".block");

		idx = Math.max(1, Math.min(idx, this.blocks));

		let $leftBar = this.$widget.find(".blocks.left .bar");
		let $rightBar = this.$widget.find(".blocks.right .bar");

		for(let i = 0; i < this.blocks; i++) {
			let $b = $blocks.eq(i);
			$b[idx > i ? "addClass" : "removeClass"]("active");
		}

		let $bar : JQuery = null;
		let percent : number = null;

		if (idx <= this.blocks/2) {
			$rightBar.hide();
			$leftBar.find(".handle").show();
			$leftBar.find(".handle-ghost").show();
			percent = idx / (this.blocks/2) * 100;
			$bar = $leftBar;

		} else {
			$rightBar.show();
			$leftBar.show().css("width", "100%");
			$leftBar.find(".handle").hide();
			$leftBar.find(".handle-ghost").hide();
			$rightBar.show();
			percent = (idx - (this.blocks/2)) / (this.blocks/2) * 100;
			$bar = $rightBar;
		}

		$bar.css({width: percent + "%"});
		if (percent === 100) $bar.addClass("full");
		else if (percent === 0) $bar.addClass("empty");
		else $bar.removeClass("empty full");

		let $price = $bar.find(".price");

		let value = this.getPrice(idx) + " " + this.translator.t("__currency");
		let txt = value.toString();
		$price.text(txt);
		this.selected = idx;
	}

	/**
	 * Create as many "wawelength" blocks as many could fit
	 * @param x The available space
	 */
	private createBlocks(x : number)
	{
		// Assume a min width;
		if (x < 1000) x = 1000;

		const buttonSize = 137; // Width of the button's container in the middle of the widget
		const blockWidth = 54;
		const padding = 50;  // Avoid getting too close to the edge

		let blockCountAtOneSide = Math.floor((x - padding - buttonSize) / blockWidth / 2);

		const $left = this.$root.find(".blocks.left");
		$left.find(".block").remove();
		const $right = this.$root.find(".blocks.right");
		$right.find(".block").remove();
		for (let i = 0; i < blockCountAtOneSide; i++)
		{
			$left.prepend("<div class='block'><span></span></div>");
			$right.prepend("<div class='block'><span></span></div>");
		}

		this.blocks = blockCountAtOneSide * 2;
	}

	private initWidget()
	{
		this.createBlocks(this.$root.width());

		this.$widget = this.$root.find(".sxccp-smarttips");

		//this.select(this.selected);
		// let buttonW = this.$root.find(".button").width();
		// let blockW = this.$root.find(".block").width();

		const buttonW = 137; // Width of the button's container in the middle of the widget
		const blockW = 54;

		this.select(this.selected);

		let onMouseMoveOrUp = (e) =>
		{
			let ww = this.$widget.width() - buttonW;
			let fromLeft = e.pageX - this.$widget.offset().left;

			let bcHalf = this.blocks / 2;

			if (fromLeft > bcHalf * blockW && fromLeft < bcHalf * blockW + buttonW) {
				fromLeft = bcHalf * blockW;
			} else if (fromLeft >= bcHalf * blockW + buttonW) {
				fromLeft = fromLeft - buttonW;
			}

			let percent = Math.min(100, Math.max(0, fromLeft / ww * 100));
			let idx = Math.round(percent / 100 * this.blocks);
			idx = Math.min(this.blocks, Math.max(1, idx));
			this.select(idx);
		};

		this.$widget.on('mousedown', (e) =>
		{
			if (e.which != 1) return;

			if ($(e.target).closest(".button").length) {
				return;
			}

			$(document).on('mouseup.smarttoywidgetslider', (e) =>
			{
				$(document)
					.off('mouseup.smarttoywidgetslider')
					.off('mousemove.smarttoywidgetslider');

				onMouseMoveOrUp(e);
			});

			$(document).on('mousemove.smarttoywidgetslider', (e) =>
			{
				onMouseMoveOrUp(e);
			});
		});
	}
}

